export default __webpack_public_path__ + "static/media/Local-FRC.845edfb3.mp4";